import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import Permissions from 'javascripts/analytics/config/permissions';
import { CountryFlag } from 'javascripts/analytics/components/country_flag';
import moment from 'moment';

export class HitsTable extends React.Component {
  static propTypes = {
    hits: PropTypes.array.isRequired,
  };

  state = {
    numVisibleRows: 10,
  };

  visibleHits = () => {
    return _.sortBy(this.props.hits, function (hit) {
      // Sort by date, show most recent first
      return -1 * hit.epoch;
    }).slice(0, this.state.numVisibleRows);
  };

  coloredHits = (hits) => {
    const hitColors = [
      '#1f77b4',
      '#aec7e8',
      '#ff7f0e',
      '#ffbb78',
      '#2ca02c',
      '#98df8a',
      '#d62728',
      '#ff9896',
      '#9467bd',
      '#c5b0d5',
      '#8c564b',
      '#c49c94',
      '#e377c2',
      '#f7b6d2',
      '#7f7f7f',
      '#c7c7c7',
      '#bcbd22',
      '#dbdb8d',
      '#17becf',
      '#9edae5',
    ];

    const visitors = _.compact(
      _.keys(
        _.groupBy(hits, function (hit) {
          return hit.visitor && hit.visitor.id;
        }),
      ),
    );

    return _.map(hits, function (hit) {
      if (hit.visitor && hit.visitor.id) {
        return _.extend({}, hit, {
          visitorColor:
            hitColors[visitors.indexOf(hit.visitor.id) % hitColors.length],
        });
      } else {
        return hit;
      }
    });
  };

  hitOccupation = (hit) => {
    return hit.visitor && hit.visitor.occupation && hit.visitor.occupation.name;
  };

  hitUniversityName = (hit) => {
    return (
      hit.visitor &&
      hit.visitor.university &&
      hit.visitor.university.display_name
    );
  };

  hitDisplayCity = (hit) => {
    return _.compact([hit.visitor.city, hit.visitor.region]).join(', ');
  };

  renderVisitorRole = (hit) => {
    if (this.hitUniversityName(hit) && this.hitOccupation(hit)) {
      return (
        <a href={hit.visitor.university.url}>
          {this.hitUniversityName(hit) + ', ' + this.hitOccupation(hit)}
        </a>
      );
    } else if (this.hitOccupation(hit)) {
      return <div>{this.hitOccupation(hit)}</div>;
    }

    return null;
  };

  renderRow = (hit) => {
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line eqeqeq
    const isHoverVisitor = hit.visitor.id == this.state.hoverVisitor;

    return (
      <tr
        className={isHoverVisitor ? 'success' : ''}
        onMouseEnter={this.setVisitor.bind(this, hit)}
        onMouseLeave={this.clearVisitor}
        key={hit.id}
      >
        <td style={{ backgroundColor: hit.visitorColor }} />
        <td>{moment(hit.epoch).format('H:mm MMM D')}</td>
        <td>
          <a href={hit.page.url}>{hit.page.title || hit.page.category}</a>
        </td>
        <td>
          {hit.referer && hit.referer.url ? (
            <a href={hit.referer.url}>{hit.referer.domain}</a>
          ) : null}
        </td>
        <td>{_.compact([hit.visitor.city, hit.visitor.region]).join(', ')}</td>
        <td>
          <CountryFlag country={hit.visitor.country} tooltip={true} />
        </td>

        {this.shouldDisplayRole() && <td>{this.renderVisitorRole(hit)}</td>}
        {this.shouldDisplayUpgradeButton() && (
          <td>{this.renderUpgradeButton()}</td>
        )}
      </tr>
    );
  };

  shouldDisplayRole = () => {
    return Permissions.inMode('premium');
  };

  shouldDisplayUpgradeButton = () => {
    return Permissions.inMode('upgradeable');
  };

  setVisitor = (hit) => {
    this.setState({
      hoverVisitor: hit.visitor.id,
    });
  };

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  clearVisitor = (hit) => {
    this.setState({
      hoverVisitor: false,
    });
  };

  moreButtonClickHandler = () => {
    this.setState({
      numVisibleRows: this.state.numVisibleRows + 20,
    });
  };

  renderMoreButton = (isVisible) => {
    return (
      <button
        type="button"
        onClick={this.moreButtonClickHandler}
        className={
          (isVisible ? '' : 'u-displayNone ') +
          'btn btn-default btn-block show-more-button u-mt4x'
        }
      >
        Show More
      </button>
    );
  };

  renderUpgradeButton = () => {
    return (
      <a href="#/readers/" className="Button Button--green Button--xs">
        Upgrade to view
      </a>
    );
  };

  render() {
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line eqeqeq
    if (this.props.hits.length == 0) return null;

    return (
      <div className="panel panel-flat a-fadeInDown">
        <div className="panel-body" style={{ overflowX: 'auto' }}>
          <table
            className="analytics-dashboard-data-table table table-bordered u-mb0x"
            style={{ tableLayout: 'auto' }}
          >
            <thead>
              <tr>
                <th style={{ width: '1%' }} />
                <th className="timestamp" style={{ width: '10%' }}>
                  Time / Date
                </th>
                <th>Page</th>
                <th>Referring Site</th>
                <th className="city">City</th>
                <th className="country">Country</th>
                {this.shouldDisplayRole() && (
                  <th className="u-fw700">
                    University & Role{' '}
                    <span className="badge u-bgColorGreen"> PREMIUM</span>
                  </th>
                )}
                {this.shouldDisplayUpgradeButton() && (
                  <th>University & Role</th>
                )}
              </tr>
            </thead>
            <tbody>
              {_.map(
                this.coloredHits(this.visibleHits()),
                function (hit) {
                  return this.renderRow(hit);
                },
                this,
              )}
            </tbody>
          </table>

          {this.renderMoreButton(
            this.props.hits.length > this.state.numVisibleRows,
          )}
        </div>
      </div>
    );
  }
}
